import { render } from "./HomeView.vue?vue&type=template&id=238f6714&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=238f6714&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238f6714"]])

export default __exports__